import './comment-templates.scss'
import templateUrl from './comment-template-view.html'
const CommentTemplateViewComponent = {
  bindings: {
    template: '<',
    showBack: '<',
    onApply: '&',
    onCopy: '&',
    onBack: '&'
  },
  templateUrl,
  controller: class CommentTemplateViewComponent {
    constructor (Storage, UserService, ProjectService, ModalService, $timeout, EventEmitter) {
      'ngInject'
      this._identify = 'CommentTemplateViewComponent'
      this.Storage = Storage
      this.UserService = UserService
      this.$timeout = $timeout
      this.EventEmitter = EventEmitter
    }



    $onChanges (changesObj) {
      if (changesObj.template) {
        console.log('Input value changed:', changesObj.template.currentValue)
        // You can now perform an action based on the new value of inputValue
        // this.scrollTo('template-overview')
      }
    };

    scrollTo (id) {
      console.log('🚀 ~ CommentTemplateViewComponent ~ scrollTo ~ id:', id)
      this.$timeout(() => {
        document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    }

    apply (variant) {
      if (this.onApply) {
        this.onApply(this.EventEmitter({
          template: this.template,
          variant: variant
        }))
      }
    }

    copy (variant) {
      if (this.onCopy) {
        this.onCopy(this.EventEmitter({
          template: this.template,
          variant: variant
        }))
      }
    }

    back () {
      if (this.onBack) {
        this.onBack()
      }
    }
  }
}

export default CommentTemplateViewComponent
